import fetchActions from 'fetchActions'

const actions = ['SET_QUERY']

const subActions = {
  LIST: fetchActions,
  CURRENT: fetchActions,
  ANSWERS: fetchActions,
  ANSWER: fetchActions,
  STATUS: fetchActions,
}

export default [actions, subActions]
